import request from "@/utils/request";

export function checkCharacterId(data) {
  return request({
    url: "/api/getRoleInfo",
    method: "post",
    data
  });
}

export function rechargeRecess(data) {
  return request({
    url: "/pay/recess",
    method: "post",
    data
  });
}

export function getProductItems(data) {
  return request({
    url: "api/getProductItemByPid",
    method: "post",
    data
  });
}
